import React, { useState } from 'react';
import { Box, Button, Typography, Select, MenuItem } from '@mui/material';

// Whiteboard, My clinic purpose
const PaginationControls = ({ page, setPage, totalPages, pageSize, setPageSize }) => {
    const [showAll, setShowAll] = useState(false);

    const generatePages = () => {
        if (totalPages <= 5 || showAll) {
            return [...Array(totalPages).keys()];
        }

        const pages = [];
        if (page <= 2) {
            pages.push(0, 1, 2);
            pages.push('dots');
            pages.push(totalPages - 1);
        } else if (page >= totalPages - 3) {
            pages.push(0);
            pages.push('dots');
            pages.push(totalPages - 3, totalPages - 2, totalPages - 1);
        } else {
            pages.push(0);
            pages.push('dots');
            pages.push(page - 1, page, page + 1);
            pages.push('dots');
            pages.push(totalPages - 1);
        }

        return pages;
    };

    const pages = generatePages();

    const handlePageClick = (value) => {
        if (value === 'dots') {
            setShowAll(true);
        } else {
            setPage(value);
        }
    };

    return (
        <Box mt={5} mb={1} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
            {/* Pagination Buttons */}
            <Box display="flex" alignItems="center" gap={1}>
                <Typography
                    onClick={() => {
                        if (page > 0) setPage(page - 1);
                    }}
                    sx={{
                        cursor: page === 0 || totalPages <= 1 ? 'default' : 'pointer',
                        fontSize: 18,
                        color: '#10141F',
                        opacity: page === 0 || totalPages <= 1 ? 0.4 : 1,
                        mr: 1,
                    }}
                >
                    Prev
                </Typography>

                {pages.map((pg, idx) =>
                    pg === 'dots' ? (
                        <Button
                            key={`dots-${idx}`}
                            onClick={() => setShowAll(true)}
                            sx={{
                                width: 54,
                                height: 54,
                                borderRadius: '12px',
                                fontSize: 18,
                                color: '#10141F',
                                backgroundColor: '#FFFFFF',
                                border: '1px solid #F1F1F1',
                            }}
                        >
                            ...
                        </Button>
                    ) : (
                        <Button
                            key={pg}
                            onClick={() => handlePageClick(pg)}
                            sx={{
                                width: 54,
                                height: 54,
                                borderRadius: '12px',
                                fontSize: 18,
                                backgroundColor: pg === page ? '#000453' : '#FFFFFF',
                                color: pg === page ? '#FFFFFF' : '#10141F',
                                border: pg === page ? 'none' : '1px solid #F1F1F1',
                            }}
                        >
                            {pg + 1}
                        </Button>
                    ),
                )}

                <Typography
                    onClick={() => {
                        if (page < totalPages - 1) setPage(page + 1);
                    }}
                    sx={{
                        cursor: page === totalPages - 1 || totalPages <= 1 ? 'default' : 'pointer',
                        fontSize: 18,
                        color: '#10141F',
                        opacity: page === totalPages - 1 || totalPages <= 1 ? 0.4 : 1,
                        ml: 1,
                    }}
                >
                    Next
                </Typography>
            </Box>

            {/* Page Size Dropdown */}
            <Box display="flex" alignItems="center">
                <Typography sx={{ mr: 1, fontSize: 16, color: '#10141F' }}>Rows per page:</Typography>
                <Select
                    value={pageSize}
                    onChange={(e) => {
                        setPageSize(e.target.value);
                        setPage(0); // reset to first page
                    }}
                    sx={{
                        height: 54,
                        fontSize: 16,
                        borderRadius: '12px',
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #F1F1F1',
                        width: 100,
                    }}
                >
                    {[10, 25, 50, 100].map((opt) => (
                        <MenuItem key={opt} value={opt}>
                            {opt}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        </Box>
    );
};

export default PaginationControls;
